const translations = {
  pl: {
    common: {
      next: 'Dalej',
      back: 'Wstecz',
      save: 'Zapisz wycenę',
      download: 'Pobierz PDF',
      newCalc: 'Nowa kalkulacja',
      delete: 'Usuń',
      close: 'Zamknij',
      add: 'Dodaj',
      quantity: 'Ilość',
      amount: 'Kwota',
      monthly: 'miesięcznie',
      perPiece: 'szt.',
      perMonth: 'mies.',
      perHour: 'godz.',
      currency: 'zł',
      history: 'Historia wycen',
      calculator: 'Kalkulator',
      noResults: 'Brak wyników',
      saved: 'Zapisano wycenę',
      deleted: 'Usunięto wycenę',
      error: 'Wystąpił błąd',
      clientName: 'Nazwa klienta (opcjonalnie)',
      clientEmail: 'Email klienta (opcjonalnie)',
      total: 'SUMA',
      net: 'netto',
    },
    steps: {
      step1: 'Forma księgowości',
      step2: 'Dokumenty',
      step3: 'Pracownicy',
      step4: 'Dodatkowe opcje',
      step5: 'Wyniki',
    },
    step1: {
      title: 'Podstawowe informacje',
      subtitle: 'Wybierz formę prowadzenia księgowości i formę prawną',
      accountingForm: 'Forma prowadzenia księgowości',
      legalEntity: 'Forma prawna',
      kpir: 'Księgowość uproszczona (KPiR)',
      kpirDesc: 'Dla jednoosobowych działalności gospodarczych',
      ryczalt: 'Ryczałt ewidencjonowany',
      ryczaltDesc: 'Prowadzisz tylko ewidencję przychodów',
      pelna: 'Pełna księgowość',
      pelnaDesc: 'Dla spółek z o.o., akcyjnych itp.',
      entities: {
        jdg: 'Jednoosobowa działalność gospodarcza',
        spolka_cywilna: 'Spółka cywilna',
        spolka_jawna: 'Spółka jawna',
        spolka_partnerska: 'Spółka partnerska',
        spolka_zoo: 'Spółka z o.o.',
        spolka_akcyjna: 'Spółka akcyjna',
        spolka_komandytowa: 'Spółka komandytowa',
        spolka_komandytowo_akcyjna: 'Spółka komandytowo-akcyjna',
        fundacja: 'Fundacja',
        stowarzyszenie: 'Stowarzyszenie',
        fundacja_rodzinna: 'Fundacja rodzinna',
        psa: 'Prosta Spółka Akcyjna (P.S.A.)',
      },
      selectEntity: 'Wybierz formę prawną',
      vatStatus: 'Status VAT',
      vatYes: 'Płatnik VAT',
      vatYesDesc: 'Firma jest czynnym podatnikiem VAT — deklaracja VAT-7: 100 zł netto',
      vatNo: 'Brak VAT',
      vatNoDesc: 'Firma nie jest podatnikiem VAT (zwolnienie)',
      vatEu: 'VAT EU',
      vatEuDesc: 'Transakcje wewnątrzwspólnotowe — deklaracja VAT EU: 80 zł netto',
    },
    step2: {
      title: 'Dokumenty księgowe',
      subtitle: 'Podaj orientacyjną liczbę pozycji księgowych przetwarzanych miesięcznie',
      docCount: 'Liczba pozycji księgowych',
      docHint: 'Faktury, zapisy bankowe, raport kasowy, amortyzacja, wynagrodzenia, zaliczki CIT, itp.',
      avgInfo: 'Średnia firma ma 20–30 pozycji/mc. Im więcej pozycji, tym wyższa cena obsługi.',
      whatIsEntry: 'Czym jest pozycja księgowa?',
      entryExplanation: 'Jedna pozycja księgowa to np. faktura krajowa (sprzedażowa lub kosztowa), pozycja w banku, zapis na raporcie kasowym, lub dokument PK. Faktury zagraniczne liczymy jako 5 pozycji (ze względu na kursy i różnice kursowe).',
      totalEntries: 'Łączna liczba pozycji księgowych',
      netPriceInfo: 'Wszystkie podane ceny są cenami netto (bez VAT)',
      viewPricing: 'Zobacz cennik',
      pricingTableTitle: 'Cennik usług księgowych',
    },
    step3: {
      title: 'Obsługa pracowników',
      subtitle: 'Podaj liczbę pracowników wymagających obsługi kadrowo-płacowej',
      employeeCount: 'Liczba pracowników',
      employeeHint: 'Wszystkie umowy (o pracę, zlecenia) — 100 zł/osobę',
      zusOwner: 'Rozliczenie ZUS właściciela',
      zusOwnerHint: 'Comiesięczne deklaracje ZUS dla właściciela — 70 zł/mies.',
      partnerCount: 'Liczba wspólników',
      partnerHint: 'Za każdego wspólnika doliczane są: deklaracja ZUS oraz zaliczka PIT',
      zusPersons: 'Osoby podlegające ZUS (zarząd/komplementariusze)',
      zusPersonsHint: 'Doliczamy 70 zł/m-c za osobę (deklaracja ZUS)',
      totalPersons: 'Łącznie do rozliczenia',
      persons: 'osób',
      perEmployee: '100 zł/osobę',
    },
    step4: {
      title: 'Specyfika działalności',
      subtitle: 'Zaznacz czynniki, które mogą wpłynąć na złożoność obsługi',
      additionalTitle: 'Dodatkowe usługi (opcjonalne)',
      additionalSubtitle: 'Dodaj usługi z katalogu, które nie są ujęte w podstawowej kalkulacji',
      selectService: 'Wybierz usługę z listy',
      addedServices: 'Dodane usługi',
      sumAdditional: 'Suma dodatkowych usług',
      specifics: {
        foreign_transactions: { name: 'Transakcje zagraniczne', desc: 'Import/eksport, transakcje UE', mod: '+15%' },
        mixed_vat: { name: 'Mieszany VAT', desc: 'Działalność opodatkowana i zwolniona', mod: '+30%' },
        cash_vat: { name: 'Metoda kasowa VAT', desc: 'Rozliczenia VAT metodą kasową', mod: '+30%' },
        eu_projects: { name: 'Ewidencja projektów unijnych', desc: 'Dodatkowa ewidencja projektu UE', mod: '+30%' },
        warehouse: { name: 'Gospodarka magazynowa', desc: 'Ewidencja magazynu', mod: '+20%' },
        foreign_language: { name: 'Obsługa w języku obcym', desc: 'Komunikacja dwujęzyczna', mod: '+40%' },
        startup: { name: 'Startup (< 1 roku)', desc: 'Nowa firma — zniżka przez 3 mies.', mod: '-20%' },
        estonian_cit: { name: 'CIT estoński', desc: 'Rozliczenia wg estońskiego CIT', mod: '+30%' },
        team5_accounts: { name: 'Księgowanie na kontach zespołu 5', desc: 'Układ rodzajowy i funkcjonalny', mod: '+30%' },
        foundation: { name: 'Fundacja / Stowarzyszenie', desc: 'Obsługa fundacji i stowarzyszeń', mod: '+40%' },
        file_import: { name: 'Import dokumentów plikami', desc: 'JPK, pliki XML, CSV', mod: '-10%' },
        vat_refunds: { name: 'Regularne zwroty VAT', desc: 'Miesięczne zwroty VAT', mod: '+50 zł' },
      },
    },
    step5: {
      title: 'Twoja wycena jest gotowa!',
      subtitle: 'Oto szczegółowa kalkulacja miesięcznych kosztów',
      included: 'W cenie zawarte jest:',
      breakdown: 'Z czego składa się cena:',
      basePrice: 'Obsługa księgowa',
      vatCost: 'Obsługa VAT',
      vatEuCost: 'VAT EU',
      employees: 'Pracownicy',
      zus: 'ZUS',
      specificsAdj: 'Specyfika działalności',
      additionalSvc: 'Dodatkowe usługi',
      finalTotal: 'SUMA KOŃCOWA',
      monthlyTotal: 'Suma miesięczna',
      modifyParams: 'Modyfikuj parametry',
      pdfTitle: 'Wycena usług księgowych',
      pdfSubtitle: 'Kurdynowski Accounting & Tax Solutions',
      dateLabel: 'Data wyceny',
      accountingLabel: 'Forma księgowości',
      entityLabel: 'Forma prawna',
      docsLabel: 'Liczba pozycji',
      employeesLabel: 'Liczba pracowników',
      sendEmail: 'Wyślij na e-mail',
      emailSent: 'Wycena wysłana na e-mail',
      emailError: 'Nie udało się wysłać e-maila',
      emailRequired: 'Podaj adres e-mail klienta',
      sending: 'Wysyłanie...',
    },
    history: {
      title: 'Historia wycen',
      subtitle: 'Przeglądaj zapisane wyceny',
      empty: 'Brak zapisanych wycen',
      date: 'Data',
      total: 'Suma',
      details: 'Szczegóły',
      backToCalc: 'Wróć do kalkulatora',
    },
    lead: {
      ctaTitle: 'Zainteresowany współpracą?',
      ctaSubtitle: 'Zostaw swoje dane, a skontaktujemy się z Tobą i przygotujemy indywidualną ofertę.',
      name: 'Imię i nazwisko',
      email: 'Adres e-mail',
      phone: 'Numer telefonu',
      company: 'Nazwa firmy',
      message: 'Wiadomość (opcjonalnie)',
      messagePlaceholder: 'Np. preferowany termin kontaktu, dodatkowe pytania...',
      submit: 'Wyślij zapytanie',
      sending: 'Wysyłanie...',
      successTitle: 'Dziękujemy za zapytanie!',
      successMsg: 'Skontaktujemy się z Tobą w ciągu 24 godzin roboczych.',
      required: 'Pole wymagane',
      invalidEmail: 'Nieprawidłowy adres e-mail',
      consent: 'Wyrażam zgodę na kontakt w celu przedstawienia oferty usług księgowych.',
    },
    leads: {
      title: 'Zapytania od klientów',
      subtitle: 'Zarządzaj zapytaniami z kalkulatora',
      empty: 'Brak zapytań',
      statusNew: 'Nowy',
      statusContacted: 'Skontaktowano',
      statusConverted: 'Pozyskano',
      statusRejected: 'Odrzucono',
      backToCalc: 'Wróć do kalkulatora',
    },
  },
  en: {
    common: {
      next: 'Next',
      back: 'Back',
      save: 'Save Quote',
      download: 'Download PDF',
      newCalc: 'New Calculation',
      delete: 'Delete',
      close: 'Close',
      add: 'Add',
      quantity: 'Quantity',
      amount: 'Amount',
      monthly: 'monthly',
      perPiece: 'pc.',
      perMonth: 'mo.',
      perHour: 'hr.',
      currency: 'PLN',
      history: 'Quote History',
      calculator: 'Calculator',
      noResults: 'No results',
      saved: 'Quote saved',
      deleted: 'Quote deleted',
      error: 'An error occurred',
      clientName: 'Client name (optional)',
      clientEmail: 'Client email (optional)',
      total: 'TOTAL',
      net: 'net',
    },
    steps: {
      step1: 'Accounting Form',
      step2: 'Documents',
      step3: 'Employees',
      step4: 'Additional Options',
      step5: 'Results',
    },
    step1: {
      title: 'Basic Information',
      subtitle: 'Choose accounting form and legal entity type',
      accountingForm: 'Accounting Method',
      legalEntity: 'Legal Entity',
      kpir: 'Simplified Bookkeeping (KPiR)',
      kpirDesc: 'For sole proprietorships',
      ryczalt: 'Flat-rate Tax',
      ryczaltDesc: 'Revenue records only',
      pelna: 'Full Bookkeeping',
      pelnaDesc: 'For LLCs, joint-stock companies, etc.',
      entities: {
        jdg: 'Sole Proprietorship',
        spolka_cywilna: 'Civil Partnership',
        spolka_jawna: 'General Partnership',
        spolka_partnerska: 'Professional Partnership',
        spolka_zoo: 'Limited Liability Company',
        spolka_akcyjna: 'Joint-Stock Company',
        spolka_komandytowa: 'Limited Partnership',
        spolka_komandytowo_akcyjna: 'Limited Joint-Stock Partnership',
        fundacja: 'Foundation',
        stowarzyszenie: 'Association',
        fundacja_rodzinna: 'Family Foundation',
        psa: 'Simple Joint-Stock Company (P.S.A.)',
      },
      selectEntity: 'Select legal entity',
      vatStatus: 'VAT Status',
      vatYes: 'VAT Payer',
      vatYesDesc: 'Company is an active VAT payer — VAT-7 declaration: 100 PLN net',
      vatNo: 'No VAT',
      vatNoDesc: 'Company is VAT-exempt',
      vatEu: 'VAT EU',
      vatEuDesc: 'Intra-community transactions — VAT EU declaration: 80 PLN net',
    },
    step2: {
      title: 'Accounting Documents',
      subtitle: 'Enter the approximate number of monthly accounting entries',
      docCount: 'Number of accounting entries',
      docHint: 'Invoices, bank statements, cash reports, depreciation, payroll, CIT advances, etc.',
      avgInfo: 'An average company has 20-30 entries/month. More entries = higher service price.',
      whatIsEntry: 'What is an accounting entry?',
      entryExplanation: 'One accounting entry is e.g. a domestic invoice (sales or cost), a bank statement line, a cash report entry, or a PK document. Foreign invoices count as 5 entries (due to exchange rates and differences).',
      totalEntries: 'Total accounting entries',
      netPriceInfo: 'All prices shown are net prices (excl. VAT)',
      viewPricing: 'View pricing table',
      pricingTableTitle: 'Accounting Services Pricing',
    },
    step3: {
      title: 'Employee Services',
      subtitle: 'Enter the number of employees requiring payroll services',
      employeeCount: 'Number of employees',
      employeeHint: 'All contract types — 100 PLN/person',
      zusOwner: 'Owner ZUS settlement',
      zusOwnerHint: 'Monthly ZUS declarations for the owner — 70 PLN/mo.',
      partnerCount: 'Number of partners',
      partnerHint: 'For each partner: ZUS declaration + PIT advance',
      zusPersons: 'ZUS persons (board/complementary partners)',
      zusPersonsHint: '70 PLN/month per person (ZUS declaration)',
      totalPersons: 'Total persons to settle',
      persons: 'persons',
      perEmployee: '100 PLN/person',
    },
    step4: {
      title: 'Business Specifics',
      subtitle: 'Select factors that may affect service complexity',
      additionalTitle: 'Additional Services (optional)',
      additionalSubtitle: 'Add catalog services not included in the base calculation',
      selectService: 'Select a service',
      addedServices: 'Added services',
      sumAdditional: 'Additional services total',
      specifics: {
        foreign_transactions: { name: 'Foreign Transactions', desc: 'Import/export, EU transactions', mod: '+15%' },
        mixed_vat: { name: 'Mixed VAT', desc: 'Taxed and exempt activities', mod: '+30%' },
        cash_vat: { name: 'Cash VAT Method', desc: 'Cash-based VAT settlements', mod: '+30%' },
        eu_projects: { name: 'EU Project Records', desc: 'Additional EU project bookkeeping', mod: '+30%' },
        warehouse: { name: 'Warehouse Management', desc: 'Inventory records', mod: '+20%' },
        foreign_language: { name: 'Foreign Language Service', desc: 'Bilingual communication', mod: '+40%' },
        startup: { name: 'Startup (< 1 year)', desc: 'New company — discount for 3 months', mod: '-20%' },
        estonian_cit: { name: 'Estonian CIT', desc: 'Estonian CIT settlements', mod: '+30%' },
        team5_accounts: { name: 'Team 5 Account Bookkeeping', desc: 'By type and function', mod: '+30%' },
        foundation: { name: 'Foundation / Association', desc: 'Foundation and association services', mod: '+40%' },
        file_import: { name: 'File Import', desc: 'JPK, XML, CSV files', mod: '-10%' },
        vat_refunds: { name: 'Regular VAT Refunds', desc: 'Monthly VAT refunds', mod: '+50 PLN' },
      },
    },
    step5: {
      title: 'Your Quote is Ready!',
      subtitle: 'Detailed calculation of monthly costs',
      included: 'Included in the price:',
      breakdown: 'Price breakdown:',
      basePrice: 'Accounting services',
      vatCost: 'VAT service',
      vatEuCost: 'VAT EU',
      employees: 'Employees',
      zus: 'ZUS (Social Security)',
      specificsAdj: 'Business specifics',
      additionalSvc: 'Additional services',
      finalTotal: 'GRAND TOTAL',
      monthlyTotal: 'Monthly total',
      modifyParams: 'Modify parameters',
      pdfTitle: 'Accounting Services Quote',
      pdfSubtitle: 'Kurdynowski Accounting & Tax Solutions',
      dateLabel: 'Quote date',
      accountingLabel: 'Accounting method',
      entityLabel: 'Legal entity',
      docsLabel: 'Entries count',
      employeesLabel: 'Employees count',
      sendEmail: 'Send via e-mail',
      emailSent: 'Quote sent to e-mail',
      emailError: 'Failed to send e-mail',
      emailRequired: 'Enter client email address',
      sending: 'Sending...',
    },
    history: {
      title: 'Quote History',
      subtitle: 'Browse saved quotes',
      empty: 'No saved quotes',
      date: 'Date',
      total: 'Total',
      details: 'Details',
      backToCalc: 'Back to calculator',
    },
    lead: {
      ctaTitle: 'Interested in working with us?',
      ctaSubtitle: 'Leave your details and we\'ll contact you with a personalized offer.',
      name: 'Full name',
      email: 'Email address',
      phone: 'Phone number',
      company: 'Company name',
      message: 'Message (optional)',
      messagePlaceholder: 'E.g. preferred contact time, additional questions...',
      submit: 'Send inquiry',
      sending: 'Sending...',
      successTitle: 'Thank you for your inquiry!',
      successMsg: 'We\'ll contact you within 24 business hours.',
      required: 'Required field',
      invalidEmail: 'Invalid email address',
      consent: 'I agree to be contacted regarding accounting service offers.',
    },
    leads: {
      title: 'Client Inquiries',
      subtitle: 'Manage calculator inquiries',
      empty: 'No inquiries',
      statusNew: 'New',
      statusContacted: 'Contacted',
      statusConverted: 'Converted',
      statusRejected: 'Rejected',
      backToCalc: 'Back to calculator',
    },
  },
};

export function t(key, language) {
  const keys = key.split('.');
  let value = translations[language];
  for (const k of keys) {
    if (value === undefined) return key;
    value = value[k];
  }
  return value || key;
}

export default translations;
